import AnimationSystem from '../System/Animation/AnimationSystem';
import Scene from './Scene';
import Game from '../Game';
import RenderSystem from '../System/Render/RenderSystem';
import PreloadUISystem from '../System/UI/PreloadUIHandler';
import PreloadSystem from '../System/Preload/PreloadSystem';

export default class PreloadScene extends Scene {

    public init() {
        this.addSystem(new AnimationSystem(Game.store));
        this.addSystem(new RenderSystem(Game.store));
        this.addSystem(new PreloadSystem(Game.store));
        this.addSystem(new PreloadUISystem(Game.store));

        this.systems.forEach(system => system.init());
    }
}
